// extracted by mini-css-extract-plugin
export var chip = "_dx-0";
export var filterDropdown = "_dx-5";
export var filterItem = "_dx-6";
export var icon = "_dx-1";
export var removeButton = "_dx-3";
export var removeIcon = "_dx-4";
export var separator = "_dx-2";